export enum PeriodType {
  Monthly = 'D',
  Biannual = 'M',
  Annual = 'Y',
}
